module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text top"
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.label,
      "items": _vm.items,
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": function($event) {
        _vm.selectChange($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0425b309","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SelectButton.vue
// module id = 1572
// module chunks = 8